import { render, staticRenderFns } from "./client-slider.vue?vue&type=template&id=c0a8c6de&"
import script from "./client-slider.vue?vue&type=script&lang=js&"
export * from "./client-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports